module.exports = __webpack_public_path__ + "static/media/3.1b05a335.png";